import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    standalone: false
})
export class PrivacyPolicyComponent {

  constructor(public dialogRef: MatDialogRef<PrivacyPolicyComponent>) {}

  public close(): void {
    this.dialogRef.close();
  }

}
